import {Translate} from './Translate';
import {ButtonFunctions} from './components/ButtonFunctions'
import {TInitModule} from "@app/interface";

export function init():TInitModule {
    return {
        component: Translate,
        buttonFunctions: ButtonFunctions
    }
}
